import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { HeaderComponent } from './header.component';
import { HeaderSearchComponent } from './search/header-search.component';


@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    HeaderComponent,
    HeaderSearchComponent
  ],
  exports: [HeaderComponent]
})

export class HeaderModule {
}
